import { useEffect, useMemo, useState } from "react"

import { FieldData, mapFilters } from "@/components/_Shared/FilterWrapper"
import { Resource, Scope } from "@/constants/permission"

import { useCustomerClientsQuery } from "@/hook/CustomerClients/useCustomerClientQuery"
import { useCustomerQuery } from "@/hook/Dictionaries/Customers/useCustomerQuery"
import { useFilterStorage } from "@/hook/useFilterStorage"
import { useFinanceOperationTypeQuery } from "@/hook/useFinanceOperationTypeQuery"
import { usePermission } from "@/hook/usePermission"

import { FINANCE_KEY } from "@/types/IFinance"
import { FilterField, FilterFieldOperator, FilterFieldType } from "@/types/ui"


export const useFinanceFilters = () => {
  const [filters, setFilters] = useState<FilterField[]>([])

  const { getFilter } = useFilterStorage({
    key: FINANCE_KEY
  })

  const oldFilters: FieldData[] = getFilter()

  const { data: operationTypes } = useFinanceOperationTypeQuery()
  const { data: customers } = useCustomerQuery()
  const { data: customerClients } = useCustomerClientsQuery()

  const { hasPermission } = usePermission()

  const isAdminOrManager = useMemo(() => {
    return hasPermission(Resource.OrderReport, Scope.Read)
  }, [hasPermission])

  useEffect(() => {
    let filters = [
      ...FinanceFilters,
      {
        text: "Тип операции",
        name: "OperationType",
        type: FilterFieldType.MultiSelect,
        values: operationTypes
      }
    ]

    if (isAdminOrManager) {
      filters = [
        ...filters,
        {
          text: "Контрагент",
          name: "CustomerId",
          type: FilterFieldType.Select,
          values: customers?.response.data
        },
        {
          text: "Клиент",
          name: "CustomerClientId",
          type: FilterFieldType.Select,
          values: customerClients?.response.data
        }
      ]
    }

    setFilters(filters)
  }, [operationTypes, customers, customerClients])

  return mapFilters(filters, oldFilters)
}

const FinanceFilters: FilterField[] = [
  {
    text: "Номер заказа",
    name: "OrderNumber",
    operator: FilterFieldOperator.Contains,
    type: FilterFieldType.Text
  },
  {
    text: "Дата",
    name: "Date",
    type: FilterFieldType.DateRange
  },
  {
    text: "Сумма",
    name: "sum",
    type: FilterFieldType.NumberWithOperator
  },
  {
    text: "Дата создания",
    name: "CreatedOn",
    type: FilterFieldType.DateRange
  }
]